/**
 * Go Green LED — Navbar
 * Glassmorphism scroll, desktop dropdowns, mobile menu & accordion.
 */
document.addEventListener('DOMContentLoaded', function () {
  var siteHeader = document.querySelector('[data-site-header]');
  var header = document.querySelector('[data-header]');
  var pills = document.querySelectorAll('[data-header-pill]');
  var logo = document.querySelector('.header__logo-img');
  var hamburger = document.querySelector('[data-mobile-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var SCROLL_THRESHOLD = 40;

  /* ── Scroll — glass morphism toggle + sticky shadow ── */
  function onScroll() {
    if (!header) return;
    var scrolled = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle('header--scrolled', scrolled);
    if (siteHeader) siteHeader.classList.toggle('site-header--scrolled', scrolled);

    pills.forEach(function (pill) {
      if (scrolled) {
        pill.classList.remove('header__pill--light');
        pill.classList.add('header__pill--glass');
      } else {
        pill.classList.remove('header__pill--glass');
        pill.classList.add('header__pill--light');
      }
    });

    // Swap nav button classes
    document.querySelectorAll('.header__nav-btn').forEach(function (btn) {
      if (scrolled) {
        btn.classList.remove('header__nav-btn--light');
        btn.classList.add('header__nav-btn--glass');
      } else {
        btn.classList.remove('header__nav-btn--glass');
        btn.classList.add('header__nav-btn--light');
      }
    });

    // Swap contact link
    document.querySelectorAll('.header__contact-link').forEach(function (el) {
      if (scrolled) {
        el.classList.remove('header__contact-link--light');
        el.classList.add('header__contact-link--glass');
      } else {
        el.classList.remove('header__contact-link--glass');
        el.classList.add('header__contact-link--light');
      }
    });

    // Swap CTA
    document.querySelectorAll('.header__cta').forEach(function (el) {
      if (scrolled) {
        el.classList.remove('header__cta--light');
        el.classList.add('header__cta--glass');
      } else {
        el.classList.remove('header__cta--glass');
        el.classList.add('header__cta--light');
      }
    });

    // Swap hamburger
    if (hamburger) {
      if (scrolled) {
        hamburger.classList.remove('header__hamburger--light');
        hamburger.classList.add('header__hamburger--glass');
      } else {
        hamburger.classList.remove('header__hamburger--glass');
        hamburger.classList.add('header__hamburger--light');
      }
    }

    // Swap logo
    if (logo) {
      var darkSrc = logo.getAttribute('data-logo-dark');
      var lightSrc = logo.getAttribute('data-logo-light');
      if (darkSrc && lightSrc) {
        logo.src = scrolled ? lightSrc : darkSrc;
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Desktop dropdowns ── */
  var CLOSE_DELAY = 150;
  var closeTimer = null;
  var navItems = document.querySelectorAll('[data-dropdown]');

  function closeAllDropdowns() {
    navItems.forEach(function (item) {
      var content = item.querySelector('[data-dropdown-content]');
      var trigger = item.querySelector('[data-dropdown-trigger]');
      if (content) content.classList.remove('header__dropdown--visible');
      if (trigger) {
        trigger.classList.remove('header__nav-btn--open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-dropdown-trigger]');
    var content = item.querySelector('[data-dropdown-content]');
    if (!trigger || !content) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      closeAllDropdowns();
      content.classList.add('header__dropdown--visible');
      trigger.classList.add('header__nav-btn--open');
      trigger.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        content.classList.remove('header__dropdown--visible');
        trigger.classList.remove('header__nav-btn--open');
        trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    });

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = content.classList.contains('header__dropdown--visible');
      closeAllDropdowns();
      if (!isOpen) {
        content.classList.add('header__dropdown--visible');
        trigger.classList.add('header__nav-btn--open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) {
      clearTimeout(closeTimer);
      closeAllDropdowns();
    }
  });

  /* ── Mobile menu ── */
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.contains('header__mobile-menu--open');
      if (isOpen) {
        mobileMenu.classList.remove('header__mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.querySelector('.header__hamburger-open').style.display = '';
        hamburger.querySelector('.header__hamburger-close').style.display = 'none';
        document.body.style.overflow = '';
      } else {
        mobileMenu.classList.add('header__mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.querySelector('.header__hamburger-open').style.display = 'none';
        hamburger.querySelector('.header__hamburger-close').style.display = '';
        document.body.style.overflow = 'hidden';
      }
    });

    // Close on link click
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileMenu.classList.remove('header__mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.querySelector('.header__hamburger-open').style.display = '';
        hamburger.querySelector('.header__hamburger-close').style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Mobile accordion ── */
  function toggleAccordion(trigger) {
    var panel = trigger.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-accordion-panel')) return;
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    // Close all
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var p = t.nextElementSibling;
      if (p) p.style.display = 'none';
      var chev = t.querySelector('.header__chevron');
      if (chev) chev.style.transform = '';
    });
    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.display = 'block';
      var chev = trigger.querySelector('.header__chevron');
      if (chev) chev.style.transform = 'rotate(180deg)';
    }
  }

  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleAccordion(trigger);
    });
    trigger.addEventListener('touchend', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleAccordion(trigger);
    });
  });

  // Hide all accordion panels by default
  document.querySelectorAll('[data-accordion-panel]').forEach(function (p) {
    p.style.display = 'none';
  });
});
